/* External */
import { memo, useCallback, useMemo } from 'react';
import { withFocusable } from '@noriginmedia/react-spatial-navigation';
import PropTypes from 'prop-types';
import { List } from 'immutable';

/* Components */
import ScrollIntoViewIfFocused from '../ScrollIntoViewIfFocused';
import { ScrollPosition } from '../ScrollView';

/* Utils */
import PreSearchCard from '../PreSearchCard';
import { noOp } from '../../utils/functions';
import { createRedirectFromCollection } from '../../utils/history';

/* Styles */
import './PreSearchContainer.scss';

function PreSearchContainer({
  pageId,
  carousel,
  realFocusKey,
  onArrowPress,
  handleSearchDefaultContentTagEvent,
}) {
  const handleEnterPress = useMemo(() => createRedirectFromCollection({
    beforeRedirect: (_, { index, collection }) => {
      sessionStorage.setItem('wasPreSearchFocused', true);
      sessionStorage.setItem('preSearchFocusedOn', `${realFocusKey}-${index}`);
      handleSearchDefaultContentTagEvent({
        data: {
          listPosition: index + 1,
          providerName: collection.title?.trim(),
        },
      });
    },
    carousel,
    pageId,
  }), [carousel, pageId, realFocusKey, handleSearchDefaultContentTagEvent]);

  const handleBecameFocused = useCallback((_, { index }) => {
    sessionStorage.setItem('preSearchFocusedOn', `${realFocusKey}-${index}`);
  }, [realFocusKey]);

  const cards = useMemo(() => carousel?.collections?.map((item, index) => (
    // eslint-disable-next-line react/no-array-index-key -- TODO: check if there's a better way
    <ScrollIntoViewIfFocused position={ScrollPosition.CENTER} key={index}>
      <PreSearchCard
        focusKey={`${realFocusKey}-${index}`}
        key={item?.id || index}
        index={index}
        item={item}
        onArrowPress={onArrowPress}
        onEnterPress={handleEnterPress}
        onBecameFocused={handleBecameFocused}
      />
    </ScrollIntoViewIfFocused>
  )), [carousel?.collections, handleBecameFocused, handleEnterPress, onArrowPress, realFocusKey]);

  return (
    <div className="dtv-html5-c-pre-search-container">
      {cards}
    </div>
  );
}

PreSearchContainer.defaultProps = {
  onArrowPress: noOp,
  carousel: undefined,
  handleSearchDefaultContentTagEvent: noOp,
};

PreSearchContainer.propTypes = {
  realFocusKey: PropTypes.string.isRequired,
  pageId: PropTypes.string.isRequired,
  carousel: PropTypes.shape({
    sourceCarouselId: PropTypes.string,
    type: PropTypes.string,
    collections: PropTypes.instanceOf(List),
  }),
  onArrowPress: PropTypes.func,
  handleSearchDefaultContentTagEvent: PropTypes.func,
};

export default memo(withFocusable()(memo(PreSearchContainer)));
